import { render, staticRenderFns } from "./TemplateLayer.vue?vue&type=template&id=3ac48aac&scoped=true&"
import script from "./TemplateLayer.vue?vue&type=script&lang=js&"
export * from "./TemplateLayer.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLayer.vue?vue&type=style&index=0&id=3ac48aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac48aac",
  null
  
)

export default component.exports